/**
 * Custom pickaxe cursor — tip tracks the pointer exactly.
 * Native CSS cursor hotspots are unreliable across browsers.
 */
(() => {
  const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
  if (!finePointer.matches) return;

  const config = window.__PICKAXE_CURSOR__;
  if (!config?.src) return;

  const hotX = Number(config.hotX || 1);
  const hotY = Number(config.hotY || 18);
  const width = Number(config.width || 64);
  const height = Number(config.height || 70);

  const boot = () => {
    const root = document.documentElement;
    root.classList.add('pickaxe-cursor-enabled');

    const el = document.createElement('div');
    el.className = 'pickaxe-cursor';
    el.setAttribute('aria-hidden', 'true');
    el.style.width = `${width}px`;
    el.style.height = `${height}px`;
    el.innerHTML = `<img src="${config.src}" alt="" width="${width}" height="${height}" draggable="false">`;
    document.body.appendChild(el);

    let visible = false;

    const show = () => {
      if (visible) return;
      visible = true;
      el.classList.add('is-visible');
    };

    const hide = () => {
      visible = false;
      el.classList.remove('is-visible');
    };

    const move = (clientX, clientY) => {
      el.style.transform = `translate3d(${clientX - hotX}px, ${clientY - hotY}px, 0)`;
      show();
    };

    window.addEventListener(
      'pointermove',
      (event) => {
        if (event.pointerType && event.pointerType !== 'mouse') return;
        move(event.clientX, event.clientY);
      },
      { passive: true }
    );

    window.addEventListener('pointerdown', (event) => {
      if (event.pointerType && event.pointerType !== 'mouse') return;
      move(event.clientX, event.clientY);
    });

    document.addEventListener('mouseleave', hide);
    window.addEventListener('blur', hide);

    const textSelector =
      'input[type="text"], input[type="email"], input[type="search"], input[type="password"], input[type="tel"], input[type="url"], input[type="number"], textarea, [contenteditable="true"]';

    document.addEventListener(
      'pointerover',
      (event) => {
        const target = event.target;
        if (!(target instanceof Element)) return;
        if (target.closest(textSelector)) {
          root.classList.add('pickaxe-cursor-text');
          hide();
        } else {
          root.classList.remove('pickaxe-cursor-text');
        }
      },
      { passive: true }
    );
  };

  if (document.body) boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();
